import {useMemo, useState} from 'react';
import {FmlxTab} from 'fmlx-common-ui';
import {ERoleId, ESelectedTabs} from '../../const/dataEnum';
import './FeedbackReview.scss';
import FeedbackFormulatrixPage from './FeedbackFormulatrixPage';
import {userSelector} from '../../stores/selectors/appStateSelector.js';
import {selectPeriodeAndAuthRole} from '../../stores/selectors/appStateSelector';
import {useSelector} from 'react-redux';
import FeedbackLeadPage from './FeedbackLeadPage';

const FeedbackReview = () => {
  const user = useSelector(userSelector);
  const {currentPeriodId, userAuthRoleId} = useSelector(selectPeriodeAndAuthRole);
  const credential = `${user.fullName} - (${'Lead'})`;
  const credetialForAdmin = userAuthRoleId === ERoleId.ADMINISTRATOR ? "Administrator" : credential

  const [selectedTab, setSelectedTab] = useState(0);

  const memoizedTabFeedback = useMemo(() => {
    return [
      {
        title: ESelectedTabs.LEAD,
        content: <FeedbackLeadPage periodId={currentPeriodId} userRole={credetialForAdmin}/>,
      },
      {
        title: ESelectedTabs.FORMULATRIX,
        content: <FeedbackFormulatrixPage periodId={currentPeriodId}/>,
      },
    ];
  }, [credetialForAdmin, currentPeriodId]);

  const handleChangeTab = ({index}) => {
    setSelectedTab(index);
  };

  return (
    <div className="feedback-container">
      <FmlxTab
        id="fmlx-tab-feedback"
        items={memoizedTabFeedback}
        selectedTab={selectedTab}
        variant={FmlxTab.Variant.FULLWIDTH}
        orientation={FmlxTab.Orientation.HORIZONTAL}
        onChange={handleChangeTab}
      />
    </div>
  );
};

export default FeedbackReview;
